export default "<p>sign-rectangle works!</p>\r\n";